const GLO_ANIME_SEARCH_FOCUS = "GLO_ANIME_SEARCH_FOCUS";
const GLO_ANIME_SEARCH_BLUR = "GLO_ANIME_SEARCH_BLUR";
const GLO_SET_ANIME_TEXT = "GLO_SET_ANIME_TEXT";
const GLO_ANIME_SEARCH_START = "GLO_ANIME_SEARCH_START";
const GLO_ANIME_SEARCH_SUCCESS = "GLO_ANIME_SEARCH_SUCCESS";
const GLO_ANIME_SEARCH_FAIL = "GLO_ANIME_SEARCH_FAIL";

export {
  GLO_ANIME_SEARCH_BLUR,
  GLO_ANIME_SEARCH_FOCUS,
  GLO_ANIME_SEARCH_START,
  GLO_ANIME_SEARCH_SUCCESS,
  GLO_ANIME_SEARCH_FAIL,
  GLO_SET_ANIME_TEXT,
};
